const MENU_AUTH_LIST = 'MENU_AUTH_LIST';
const TMS_ADMIN_ACCOUNT = 'TMS_ADMIN_ACCOUNT';
const TMS_ADMIN_TOKEN = 'TMS_ADMIN_TOKEN';

export { MENU_AUTH_LIST, TMS_ADMIN_ACCOUNT, TMS_ADMIN_TOKEN };
